<template>
	<div class="d-flex flex-md-row flex-column gap-4">
		<ClubServiceCard
			v-for="(advantage, advantage_i) in data.advantages"
			:key="advantage_i"
			:refName="advantage.refName"
			:advantage="advantage"
		>
			<template #icon>
				<component :is="advantage.cardTitleIcon"></component>
			</template>
			<template #title>
				<span class="title-4 text-grey-900">
					{{ advantage.title }}
				</span>
			</template>
			<template #content v-if="advantage.cardComponent">
				<component
					:is="advantage.cardComponent"
					:advantage="advantage"
				></component>
			</template>
			<template #content v-else>
				<div
					class="show-more-less-text text-grey-900 body"
					v-html="advantage.cardContent"
				></div>
			</template>
		</ClubServiceCard>
	</div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from "vue"

// Classes
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage"

// Components
import ClubServiceCard from "@/vue/club-advantages/components/ClubServiceCard.vue"
import InfantClubContent from "@/vue/club-advantages/components/InfantClubContent.vue"

// Popup Components
import DefaultPopUp from "@/vue/club-advantages/components/DefaultPopUp.vue"
import InfantClubPopUp from "@/vue/club-advantages/components/InfantClubPopUp.vue"

// Icons
import RestaurationIcon from "@/vue/club-advantages/components/RestaurationIcon.vue"
import InfantClubIcon from "@/vue/club-advantages/components/InfantClubIcon.vue"
import AnimationIcon from "@/vue/club-advantages/components/AnimationIcon.vue"
import wellBeingIcon from "@/vue/club-advantages/components/wellBeingIcon.vue"

// Builders
import buildInfantClubs from "@/vue/club-advantages/builder/buildInfantClubs"

// State
import state from "@/vue/club-advantages/state/state"

// Data
interface Data {
	advantages: ClubAdvantage[]
}

const data: Data = reactive({
	advantages: [],
})

// Methods
const addAdvantages = (): void => {
	try {
		if (window!.lihe.restaurantDescription) {
			data.advantages.push(
				new ClubAdvantage(
					"restauration",
					RestaurationIcon,
					window.content.liheDesc_includeRestaurationSegment,
					false,
					window.lihe.restaurantDescription,
					"",
					undefined,
					DefaultPopUp
				)
			)
		}

		if (window!.lihe.clubs && window.lihe.clubs.length) {
			buildInfantClubs()
			if (!state.hideClubs) {
				data.advantages.push(
					new ClubAdvantage(
						"InfantClub",
						InfantClubIcon,
						window.content.kids_club,
						false,
						undefined,
						undefined,
						InfantClubContent,
						InfantClubPopUp
					)
				)
			}
		}

		if (window!.lihe.animation) {
			if (!window.lihe.animation.yourAnim)
				throw new Error("animation missing content in addAdvantages")
			data.advantages.push(
				new ClubAdvantage(
					"animation",
					AnimationIcon,
					window.content.entertainment,
					false,
					window.lihe.animation.yourAnim,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}

		// TODO, check field name once the welness field is added to the backoffice
		if (window!.lihe.wellBeing) {
			data.advantages.push(
				new ClubAdvantage(
					"wellBeing",
					wellBeingIcon,
					window.content.wellness,
					false,
					window.lihe.wellBeing,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}
	} catch (e) {
		hideAdvantagesTitle()
	}
}

const hideAdvantagesTitle = (): void => {
	const clubsTitle: HTMLElement | null =
		document.querySelector("[data-clubstitle]")
	if (!data.advantages.length && clubsTitle) {
		clubsTitle.style.display = "none"
	}
}

onMounted(() => {
	addAdvantages()
	// Hide the title if no results
})
</script>

<style>
.plus-info-inner-wrapper {
	border-radius: var(--border-radius-secondary);
	padding: 30px;
}

@media (max-width: 576px) {
	.plus-info-inner-wrapper {
		padding: 0px;
	}
}
</style>
